<div class="not-found-container">
    <img src="./assets/images/no-results.png" alt="waiting-list" width="185px" class="not-found-icon">
    <h2 class="not-found-title" translate>Oops! The page you're looking for doesn't exist</h2>
</div>